<template>
  <div class="fixed z-10 inset-0 overflow-y-auto">
    <div class="flex items-center py-8 justify-center min-h-screen">
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-black opacity-50"></div>
      </div>
      <div
        class="bg-white rounded-lg overflow-hidden shadow-xl z-50 px-6 py-6 min-w-[90vw] md:min-w-[40vw]"
      >
        <div class="flex justify-between items-center mb-6">
          <h2 class="text-xl font-medium text-gray-800 dark:text-white">
            Actualizar configuración de pagos
          </h2>
          <button
            @click="isActive"
            class="text-gray-500 hover:text-gray-700 w-8 h-8 flex items-center justify-center hover:bg-gray-200 rounded-lg"
          >
            <svg class="w-5 h-5">
              <use href="../../../../assets/svg/icon.svg#cancel" />
            </svg>
          </button>
        </div>
        <LoadingForms v-if="!isLoading" />
        <form class="w-full space-y-6" @submit.prevent v-else>
          <div class="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
            <label class="block">
              <span
                class="block mb-2 text-sm font-medium text-gray-800 dark:text-white"
              >
                Tipos de afilización
              </span>
              <select
                class="py-2 px-3 text-sm text-gray-600 uppercase border-2 focus:border-blue-500 block w-full rounded-lg mb-2 bg-gray-50 outline-none"
                v-model="dataForm.membershipType"
              >
                <option value="AFP CRECER">AFP CRECER</option>
                <option value="AFP POPULAR">AFP POPULAR</option>
                <option value="AFP RESERVAS">AFP RESERVAS</option>
                <option value="AFP SIEMBRA">AFP SIEMBRA</option>
                <option value="AFP ROMANA">AFP ROMANA</option>
                <option value="AFP ATLANTICO">AFP ATLANTICO</option>
                <option value="AFP JMMB">AFP JMMB</option>
                <option value="ONP">ONP</option>
              </select>
            </label>

            <label class="block">
              <span
                class="block mb-2 text-sm font-medium text-gray-800 dark:text-white"
              >
                Descuento por afiliación (%)
              </span>
              <input
                type="text"
                class="py-2 px-2 text-sm bg-gray-50 outline-none rounded-lg text-gray-600 w-full border-2 focus:border-blue-500"
                v-model="dataForm.discount"
                placeholder="Descuento por afiliación (%)..."
                @keydown.enter="validatePayment"
                @keydown.enter.prevent
              />
            </label>
            <label class="block">
              <span
                class="block mb-2 text-sm font-medium text-gray-800 dark:text-white"
              >
                Asignación familiar (%)
              </span>
              <input
                type="text"
                class="py-2 px-2 text-sm bg-gray-50 outline-none rounded-lg text-gray-600 w-full border-2 focus:border-blue-500"
                v-model="dataForm.householdAllowance"
                placeholder="Asignación familiar (%)..."
                @keydown.enter="validatePayment"
                @keydown.enter.prevent
              />
            </label>
            <label class="block">
              <span
                class="block mb-2 text-sm font-medium text-gray-800 dark:text-white"
              >
                Salario base
              </span>
              <input
                type="text"
                class="py-2 px-2 text-sm bg-gray-50 outline-none rounded-lg text-gray-600 w-full border-2 focus:border-blue-500"
                v-model="dataForm.baseSalary"
                placeholder="Salario base..."
                @keydown.enter="validatePayment"
                @keydown.enter.prevent
              />
            </label>
            <label class="block">
              <span
                class="block mb-2 text-sm font-medium text-gray-800 dark:text-white"
              >
                Pago mensual
              </span>
              <input
                type="text"
                class="py-2 px-2 text-sm bg-gray-50 outline-none rounded-lg text-green-600 w-full border-2 border-green-500 focus:border-blue-500"
                v-model="dataForm.amounthPayment"
                placeholder="Pago mensual..."
                readonly
              />
            </label>
            <label class="block">
              <span
                class="block mb-2 text-sm font-medium text-gray-800 dark:text-white"
              >
                Pago por H. extras
              </span>
              <input
                type="text"
                class="py-2 px-2 text-sm bg-gray-50 outline-none rounded-lg text-gray-600 w-full border-2 focus:border-blue-500"
                v-model="dataForm.overtimePay"
                placeholder="Pago por horas extra..."
              />
            </label>
            <label class="block">
              <span
                class="block mb-2 text-sm font-medium text-gray-800 dark:text-white"
              >
                Minutos extra acumulado
              </span>
              <input
                type="text"
                class="py-2 px-2 text-sm bg-gray-50 outline-none rounded-lg text-orange-600 w-full border-2 focus:border-blue-500"
                v-model="dataForm.accumulatedOvertime"
                placeholder="Minutos extra acumulado.."
                disabled
              />
            </label>
            <label class="block">
              <span
                class="block mb-2 text-sm font-medium text-gray-800 dark:text-white"
              >
                Comision por ventas
              </span>
              <input
                type="text"
                class="py-2 px-2 text-sm bg-gray-50 outline-none rounded-lg text-gray-600 w-full border-2 focus:border-blue-500"
                v-model="dataForm.commission"
                placeholder="Comision por ventas..."
                disabled
              />
            </label>
            <label class="block">
              <span
                class="block mb-2 text-sm font-medium text-gray-800 dark:text-white"
              >
                Codigo de barras
              </span>
              <input
                type="text"
                class="py-2 px-2 text-sm bg-gray-50 outline-none rounded-lg text-gray-600 w-full border-2 focus:border-blue-500"
                v-model="dataForm.barCode"
                placeholder="Código de barras.."
              />
            </label>

            <label class="flex flex-col h-6 mr-5 cursor-pointer">
              <span
                class="block mb-2 text-sm font-medium text-gray-800 dark:text-white"
              >
                Estado del usuario
              </span>
              <div
                class="relative inline-flex items-center h-6 mr-5 mt-2 cursor-pointer"
              >
                <input
                  type="checkbox"
                  class="sr-only peer"
                  v-model="dataForm.isMarker"
                />
                <div
                  class="w-11 h-6 bg-gray-300 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-1 after:left-[4px] after:bg-white after:border-transparent after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-green-500"
                ></div>
                <span
                  class="ml-3 text-sm font-medium text-gray-600 dark:text-gray-300"
                >
                  {{
                    dataForm.isMarker === true
                      ? "Si marca asistencia"
                      : "No marca asistencia"
                  }}
                </span>
              </div>
            </label>
          </div>

          <div class="flex mt-[3.5rem!important]">
            <button
              class="bg-blue-500 text-white px-4 py-2 font-semibold text-sm rounded-lg hover:shadow-sm hover:shadow-blue-600 active:scale-95 flex items-center"
              @click="update"
              :disabled="spinner === true"
            >
              <div class="flex items-center" v-if="spinner">
                <svg class="w-4 h-4 mr-3 animate-spin">
                  <use href="../../../../assets/svg/icon.svg#spinnerForBlue" />
                </svg>
                Modificando Información
              </div>
              <span v-else>Modificar</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, ref } from "vue";
import { confirmationOfUpdate, errorActions } from "@/alerts";
import { observer } from "@/observer";
import axios from "../../../../api";

//componente de loading
import LoadingForms from "@/components/Loadings/LoadingFormsLarge.vue";
import { percentage } from "@/publicjs/convertToPercentage";
export default {
  name: "UpdateTurns",
  components: {
    LoadingForms,
  },
  props: {
    activeModal: {
      type: Function,
      required: true,
    },
    getdata: {
      type: Function,
      required: true,
    },
    id: {
      type: Number,
      required: true,
    },
  },
  setup(props) {
    async function isActive() {
      await props.activeModal(true);
    }

    const spinner = ref(false);

    const dataForm = ref({
      membershipType: "AFP CRECER",
      discount: 0,
      householdAllowance: 0,
      baseSalary: 0,
      amounthPayment: 0,
      overtimePay: 0,
      accumulatedOvertime: 0,
      commission: 0,
      isMarker: false,
      barCode: "",
    });

    // el isLoading se aplica para validar que la api aya sido consumido o cargado al 100 y recien ahi cargamos el componente
    const isLoading = ref(false);
    onMounted(async () => {
      const response = await axios
        .get("contrataciones/" + props.id)
        .catch((error) => errorActions(error));
      const data = await response.data;
      dataForm.value.membershipType = data.tipo_afiliacion;
      dataForm.value.discount = data.descuento_por_afiliacion;
      dataForm.value.householdAllowance = data.asignacion_familiar;
      dataForm.value.baseSalary = data.sueldo_base;
      dataForm.value.amounthPayment = data.pago_mensual;
      dataForm.value.overtimePay = data.pago_por_horas_extra;
      dataForm.value.accumulatedOvertime = data.hora_extra_acumulada;
      dataForm.value.commission = data.comision_acumulado;
      dataForm.value.isMarker = data.marca_asistencia===1?true:false;
      dataForm.value.barCode = data.codigo_de_barra;

      isLoading.value = true;
    });

    //funcion para validar pago
    const validatePayment = () => {
      const discount =
        parseFloat(dataForm.value.baseSalary) *
        percentage(dataForm.value.discount);
      const payment = parseFloat(dataForm.value.baseSalary) - discount;
      const householdAllowance =
        payment * percentage(dataForm.value.householdAllowance);
      const totalPayment = payment + householdAllowance;
      dataForm.value.amounthPayment = totalPayment;
    };

    const update = async () => {
      if (dataForm.value.amounthPayment <= 50) {
        errorActions(
          "Por favor ingresa un sueldo minimo segun tu país para el  <strong>personal</strong>"
        );
        observer.observe(
          document.querySelector(".swal2-container"),
          { box: "content-box" },
          10
        );
        return;
      }

      spinner.value = true;

      const response = await axios
        .put(
          "contrataciones/" + props.id,
          {
            membershipType: dataForm.value.membershipType,
            discount: dataForm.value.discount,
            householdAllowance: dataForm.value.householdAllowance,
            baseSalary: dataForm.value.baseSalary,
            amounthPayment: dataForm.value.amounthPayment,
            overtimePay: dataForm.value.overtimePay,
            accumulatedOvertime: dataForm.value.accumulatedOvertime,
            commission: dataForm.value.commission,
            isMarker: dataForm.value.isMarker ? 1 : 0,
            barCode: dataForm.value.barCode,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
        .catch(function (error) {
          errorActions(error);
        });
      const data = await response.data;
      if (data.msg === true) {
        confirmationOfUpdate(
          "<trong>Configuración de pagos del personal </strong>"
        );
        observer.observe(
          document.querySelector(".swal2-container"),
          { box: "content-box" },
          10
        );
        await props.activeModal(false);
        await props.getdata();
      } else if (data.msg === "Request failed with status code 500") {
        errorActions("Request failed with status code 500");
        observer.observe(
          document.querySelector(".swal2-container"),
          { box: "content-box" },
          10
        );
      } else if (data.status === 404) {
        errorActions(
          "la configuracion de pago del <trong>personal</strong> que estas intentando actualizar no existe en nuestra base de datos"
        );
        observer.observe(
          document.querySelector(".swal2-container"),
          { box: "content-box" },
          10
        );
      } else {
        errorActions(
          "Lo sentimos no pudimos actualizar la configuracion de pago del <trong>personal</strong> "
        );
        observer.observe(
          document.querySelector(".swal2-container"),
          { box: "content-box" },
          10
        );
      }
    };

    return {
      isActive,
      dataForm,
      update,
      isLoading,
      spinner,
      validatePayment,
    };
  },
};
</script>
